import { useTranslation} from 'react-i18next';
import React             from "react";
import { Link }          from "react-router-dom";
import RouterHelper      from '../Helper/RouterHelper';
import { isGerman }      from '../Helper/Helper';
import { getGuest }      from '../Helper/SessionHelper';



function FooterMeta({showConditions = true}) {
    const {t}   = useTranslation();
    const guest                  = getGuest();
    let imprintLink               = RouterHelper.Routes.DE.IMPRINT;
    let conditionsLink            = RouterHelper.Routes.DE.CONDITIONS;
    let dataProtectionLink        = RouterHelper.Routes.DE.DATA_PROTECTION;
    let complianceNoticeLink     = RouterHelper.Routes.DE.COMPLIANCE_NOTICE;
    let contractRevocationLink   = "https://support.visit-x.net/hc/de/requests/new?tf_28097877372818=withdrawal";
    if (!isGerman()) {
        imprintLink               = RouterHelper.Routes.EN.IMPRINT;
        conditionsLink            = RouterHelper.Routes.EN.CONDITIONS;
        dataProtectionLink        = RouterHelper.Routes.EN.DATA_PROTECTION;
        complianceNoticeLink     = RouterHelper.Routes.EN.COMPLIANCE_NOTICE;
        contractRevocationLink   = "https://support.visit-x.net/hc/en-us/requests/new?tf_28097877372818=withdrawal";
    }

    if (guest?.screenname) {
        contractRevocationLink += "&tf_22854824538258=" + encodeURIComponent(guest.screenname);
    }

    return (
        <div className={"footer__meta"}>
            <Link className={"footer__meta-item"} to={imprintLink} >{t('ImprintLink')}</Link>
            {showConditions && <Link className={"footer__meta-item"} to={conditionsLink} >{t('AbgLink')}</Link>}
            <Link className={"footer__meta-item"} to={dataProtectionLink} >{t('DataProtectionLink')}</Link>
            <Link className={"footer__meta-item footer__meta-item--compliance"} to={complianceNoticeLink} >{t('ComplianceNoticeLink')}</Link>
            <a className={"footer__meta-item footer__meta-item--revocation"} href={contractRevocationLink} rel="noopener noreferrer" target="_blank">{t('ContractRevocationLink')}</a>
        </div>
    )
}

export default FooterMeta;
